import { Collapse, Breadcrumb } from 'antd';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';
import Layout from '~/v2/components/layout/Layout';

import faqData from '../data/pages/faq.json';

const Container = dynamic(() => import('../components/other/Container'));
const SectionTitle = dynamic(() => import('~/v2/components/typography/SectionTitle'));

export default function Faq() {
  const { Panel } = Collapse;

  return (
    <Layout
      title='FAQ'
      head={
        <>
          <link rel='canonical' href='https://coffeepii.com/faq' />
        </>
      }
    >
      <Container>
        <Breadcrumb separator='>'>
          <Breadcrumb.Item>
            <i className='fas fa-home' />
            <FormattedMessage id='app.common.home' defaultMessage='Home' />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <FormattedMessage id='app.common.faq' defaultMessage='FAQ' />
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className='faq'>
          <SectionTitle
            title={<FormattedMessage id='app.common.faq' defaultMessage='FAQ' />}
            className='-left'
            hideDecoration={undefined}
            style={undefined}
          />

          <Collapse accordion defaultActiveKey={[1]} ghost>
            {faqData.map((item, index) => (
              <Panel header={<FormattedMessage id={item.title_id} defaultMessage={item.title} />} key={index + 1}>
                <p>
                  <FormattedMessage id={item.content_id} defaultMessage={item.content} />
                </p>
              </Panel>
            ))}
          </Collapse>
        </div>
      </Container>
    </Layout>
  );
}
